import React from "react";
import PropTypes from "prop-types";
import { Tooltip as MuiTooltip } from "@mui/material";
import Fade from "@mui/material/Fade";
import { useState } from "react";
import { useRef } from "react";
import { useEffect } from "react";

const Tooltip = React.forwardRef(
  (
    {
      title,
      children,
      placement = "bottom",
      maxChars = 20,
      isIcon = false,
      theme = "dark",
      className,
      ...props
    },
    ref
  ) => {
    const [needsTooltip, setNeedsTooltip] = useState(false);
    const textRef = useRef(null);

    useEffect(() => {
      if (!title) return;

      if (typeof title !== "string") {
        // If title is JSX → always show tooltip
        setNeedsTooltip(true);
        return;
      }
      if (textRef.current) {
        // Check both character length and actual rendered width
        // const isOverflowing =
        //   title.length > maxChars ||
        //   textRef.current.scrollWidth > textRef.current.clientWidth;
        // setNeedsTooltip(isOverflowing);
      }
    }, [title, maxChars]);

    return (
      <MuiTooltip
        title={title}
        arrow
        placement={placement}
        ref={ref}
        className={`custom-tooltip ${className || ""}`}
        slots={{ transition: Fade }}
        // disableHoverListener={isIcon ? false : !needsTooltip}
        slotProps={{
          transition: { timeout: 600 },
          tooltip: {
            className: `tooltip-content ${theme}-theme`,
            id: "tooltip-content",
          },
          popper: {
            className: "tooltip-popper",
          },
        }}
        {...props}
      >
        {/* Ensure children can receive focus/hover */}
        {isIcon ? (
          <span className="tooltip-children">{children}</span>
        ) : (
          <span className="tooltip-children" ref={textRef}>
            {children || title}
          </span>
        )}
      </MuiTooltip>
    );
  }
);

Tooltip.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  children: PropTypes.node.isRequired,
  placement: PropTypes.oneOf([
    "auto-end",
    "auto-start",
    "auto",
    "top-start",
    "top",
    "top-end",
    "right-start",
    "right",
    "right-end",
    "bottom-start",
    "bottom",
    "bottom-end",
    "left-start",
    "left",
    "left-end",
  ]),
  theme: PropTypes.oneOf(["light", "dark", "infoyellow"]),
};

export default Tooltip;
